module.exports = __webpack_public_path__ + "static/media/logo_light.221ab79c.svg";